/**
 * @generated SignedSource<<4b8878c4c4ae6d636d65d87ffd372249>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type withFieldLabel_AtlassianConversationAssistantPreviewCard$data = {
  readonly " $fragmentSpreads": FragmentRefs<"fieldLabel_AtlassianConversationAssistantPreviewCard">;
  readonly " $fragmentType": "withFieldLabel_AtlassianConversationAssistantPreviewCard";
};
export type withFieldLabel_AtlassianConversationAssistantPreviewCard$key = {
  readonly " $data"?: withFieldLabel_AtlassianConversationAssistantPreviewCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"withFieldLabel_AtlassianConversationAssistantPreviewCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "withFieldLabel_AtlassianConversationAssistantPreviewCard",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "fieldLabel_AtlassianConversationAssistantPreviewCard"
    }
  ],
  "type": "JiraIssueField",
  "abstractKey": "__isJiraIssueField"
};

(node as any).hash = "7a13656f5931b6c1efb58f603c133064";

export default node;
